module.exports = __webpack_public_path__ + "static/miDT-afb1932daf8efa820ac9ca26ebc4c7be.png";